import api from './api'

/**
 * Get access token to chat.
 * @param {string} identity 
 * @returns {Promise<string>} token
 */
function getAccessToken(identity) {
    return api.post('/support/get-token', { identity })
}

function notifyUser(message, username) {
    return api.post('/support/notify-user', { message, username })
}

function getManagers() {
    return this.$axios.get("/user/get-managers");
}

export {
    getAccessToken,
    notifyUser,
    getManagers
}